export const isFileImage = (file) => {
    if(file) return file['type'].includes('image')
    else return false
}